export default {"src":"/_next/static/media/nuxtJS.0d94fb0c.svg","height":191,"width":256,"blurWidth":0,"blurHeight":0};